var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCostDown = function SvgCostDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 128,
    width: 128,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cost-down_svg__b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7eb8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cost-down_svg__a",
    d: "M29 35h13L21 56 0 35h13V0h16z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "cost-down_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#cost-down_svg__a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 74.954V74c0-4.418-8.059-8-18-8v-5c0 3.314 7.163 6 16 6s16-2.686 16-6v8c0 3.06-6.107 5.585-14 5.954zm0 10v-8c7.893-.37 14-2.894 14-5.954v8c0 3.06-6.107 5.585-14 5.954zm0 10v-8c7.893-.37 14-2.894 14-5.954v8c0 3.06-6.107 5.585-14 5.954zM84 41v8c0 3.314-7.163 6-16 6s-16-2.686-16-6v-8c0 3.314 7.163 6 16 6s16-2.686 16-6zm0 10v8c0 3.314-7.163 6-16 6s-16-2.686-16-6v-8c0 3.314 7.163 6 16 6s16-2.686 16-6zm-16-6c-8.837 0-16-2.686-16-6s7.163-6 16-6 16 2.686 16 6-7.163 6-16 6z",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 75c-8.837 0-16-2.686-16-6v-8c0 3.314 7.163 6 16 6s16-2.686 16-6v5.049C41 66.49 34 69.882 34 74zm0 10c-8.837 0-16-2.686-16-6v-8c0 3.314 7.163 6 16 6zm0 10c-8.837 0-16-2.686-16-6v-8c0 3.314 7.163 6 16 6zm16-64v8c0 3.314-7.163 6-16 6s-16-2.686-16-6v-8c0 3.314 7.163 6 16 6s16-2.686 16-6zm0 10v8c0 3.314-7.163 6-16 6s-16-2.686-16-6v-8c0 3.314 7.163 6 16 6s16-2.686 16-6zm0 10v8c0 3.314-7.163 6-16 6s-16-2.686-16-6v-8c0 3.314 7.163 6 16 6s16-2.686 16-6zM34 35c-8.837 0-16-2.686-16-6s7.163-6 16-6 16 2.686 16 6-7.163 6-16 6z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73 22)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#cost-down_svg__b)",
    xlinkHref: "#cost-down_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#33a0ff",
    mask: "url(#cost-down_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-75-20H53v128H-75z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68 76v8c0 3.314-7.163 6-16 6s-16-2.686-16-6v-8c0 3.314 7.163 6 16 6s16-2.686 16-6zm0 10v8c0 3.314-7.163 6-16 6s-16-2.686-16-6v-8c0 3.314 7.163 6 16 6s16-2.686 16-6zm0 10v8c0 3.314-7.163 6-16 6s-16-2.686-16-6v-8c0 3.314 7.163 6 16 6s16-2.686 16-6zM52 80c-8.837 0-16-2.686-16-6s7.163-6 16-6 16 2.686 16 6-7.163 6-16 6z",
    fill: "#e6e6e6"
  }))));
};
export default SvgCostDown;